<p>
    {{ survey.text }}
</p>

<form #surveyForm="ngForm" (ngSubmit)="submitSurvey()">
    @for (item of survey.survey_options; track item.id) {
        <label [for]="item.id">
            <div class="percentage-progress" [style.marginLeft]="calculatePercentage(item.votes) + '%'"></div>
            <input type="radio" 
                   [id]="item.id" 
                   name="surveyOption"
                   [value]="item.id"
                   [(ngModel)]="selectedOptionId"
                   [checked]="item.id === survey.my_vote"
                   (change)="onOptionSelect(item)">
            {{ item.name }}
            <span class="percentage">{{ calculatePercentage(item.votes) }}%</span>
        </label>
    }
</form>